export const DATA_LAYER_PAGE_NAMES = {
  FLIGHT_LISTING_PAGE: "flightsearchlist",
  FLIGHT_RESERVATION_PAGE: "flightpassengerdetails",
  FLIGHT_PAYMENT_PAGE: "flightpayment",
  FLIGHT_PAYMENT_COMPLETED_PAGE: "flightsuccesspage",
  USER_PROFILE_PAGE: "userprofile",
  ALL_SERVICES_PAGE: "allservicespage",
  STORED_CARDS_PAGE: "userstoredcards",
  POINT_HISTORY_PAGE: "userpointhistory",
  PROMOTIONS: "promotions",
  LOGIN_REGISTER_PAGE: "loginregister",
  API_SERVICE_PAGE: "apilandingpage",
  CREDIT_CARD_POINTS_PAGE: "userconvertccpoints",
  SOCIAL_MEDIA_PERMISSIONS_PAGE: "socialmediapermissions",
  ABOUT_US: "aboutus",
  PRIVACY_POLICY_PAGE: "privacypolicy",
  COOKIE_POLICY_PAGE: "cookiepolicy",
  TERMS_OF_SERVICE_PAGE: "termsservice",
  DATA_PROTECTION_PAGE: "protectionpersonaldata",
  CONTACT_PAGE: "contactpage",
  FAQ_PAGE: "faqpage",
  COMMERCIAL_MESSAGE_CONSENT_PAGE: "electronicmessagepolicy",
  PUBLIC_HOLIDAYS_PAGE: "publicholidays",
  FLIGHT_ROUTE_PAGE: "flightroutepage",
  CITY_PAGE: "citypage",
  COUNTRY_PAGE: "countrypage",
  AIRPORT_PAGE: "airportpage",
  AIRLINE_PAGE: "airlinepage",
  FLIGHT_CONTINENT_PAGE: "flightcontinentpage",
  FLIGHT_COMPANY_PAGE: "flightcompanypage",
  FLIGHT_ALL_AIRLINE_PAGE: "flightallairlinepage",
  FLIGHT_ALL_AIRPORT_PAGE: "flightallairportpage",
  FLIGHT_MAIN_PAGE: "flightmainpage",
  AIRLINE_PROMOTION_PAGE: "airlinepromotionpage",
  MAIN_PAGE: "mainpage",
  FLIGHT_DOMESTIC_PAGE: "flightdomesticpage",
  FLIGHT_INTERNATIONAL_PAGE: "flightinternationalpage",
  FERRY_HOME_PAGE: "ferryhomepage",
  FERRY_LOCATION_PAGE: "ferrylocation",
  FERRY_ISLAND_PAGE: "ferryislandpage",
  FERRY_PORT_PAGE: "ferryportpage",
  FERRY_ROUTE_PAGE: "ferryroute",
  FERRY_COMPANY_PAGE: "ferrycompany",
  FERRY_COMPANY_LIST_PAGE: "ferryallcompanypage",
  FERRY_SEARCH_LIST_PAGE: "ferrysearchlist",
  FERRY_PASSENGER_DETAILS_PAGE: "ferrypassengerdetails",
  FERRY_PAYMENT_PAGE: "ferrypayment",
  FERRY_SUCCESS_PAGE: "ferrysuccesspage",

  // Bus page types
  BUS_TRIP_CITY_PAGE: "bustripcitypage",
  BUS_DISTRICT_PAGE: "busdistrictpage",
  BUS_COMPANY_PAGE: "buscompanypage",
  BUS_TRIP_ROUTE_PAGE: "bustriproutepage",
  BUS_TERMINAL_PAGE: "bustripterminalpage",
  BUS_ALL_TERMINAL_PAGE: "busallterminalpage",
  BUS_ALL_COMPANY_PAGE: "busallcompanypage",
  BUS_MAIN_PAGE: "busmainpage",
  BUS_TRIP_SEARCH_LIST: "bustripsearchlist",
  BUS_RESERVATION_PAGE: "bustrippassengerdetails",
  BUS_RESERVATION_DETAIL_PAGE: "bustripreservationdetails",
  BUS_RESERVATION_CANCELLATION_PAGE: "bustripcancellation",
  BUS_PAYMENT_PAGE: "buspaymentpage",
  BUS_SUCCESS_PAGE: "bussuccesspage",
  // Car page types
  CAR_MAIN_PAGE: "carmainpage",
  CAR_SEARCH_PAGE: "carsearchpage",
  CAR_RESERVATION_PAGE: "cardetailpage",
  CAR_PAYMENT_PAGE: "carpaymentpage",
  CAR_CITY_PAGE: "carcitypage",
  CAR_DISTRICT_PAGE: "cardistrictpage",
  CAR_AIRPORT_PAGE: "carairportpage",
  CAR_COMPANY_LIST_PAGE: "carcompanylistingpage",
  CAR_COMPANY_DETAIL_PAGE: "carcompanypage",
  CAR_SUCCESS_PAGE: "carsuccesspage",
  CAR_BOOKING_DETAIL_PAGE: "carbookingdetail",
  // Hotel page types
  HOTEL_MAIN_PAGE: "hotelmainpage",
  HOTEL_SEARCH_LIST: "hotelsearchlist",
  HOTEL_DETAIL: "hoteldetail",
  HOTEL_LANDING: "hotellanding",
  HOTEL_RESERVATION: "hotelreservation",
  HOTEL_RESERVATION_DETAIL: "hotelreservationdetail",
  HOTEL_PAYMENT: "hotelpayment",
  HOTEL_SUCCESS: "hotelsuccess",
  HOTEL_ABROAD: "hotelabroad",
};

export const DATA_LAYER_EVENT_NAMES = {
  VIRTUAL_USER_INFO: "virtual_user_info",
  VIRTUAL_PV: "virtual_pv",
  VIEW_ITEM_LIST: "view_item_list",
  SEARCH_RESULT: "search_result",
  VIEW_ITEM: "view_item",
  SELECT_ITEM: "select_item",
  ADD_TO_CART: "add_to_cart",
  BEGIN_CHECKOUT: "begin_checkout",
  ADD_PAYMENT_INFO: "add_payment_info",
  FILTER_APPLIED: "filter_applied",
  PURCHASE: "purchase",
  SELECT_COUPON: "select_coupon",
  VIEW_COUPON: "view_coupon",
  COUPON_APPLIED: "coupon_applied",
  SET_ALERT: "set_alert",
  SIGN_UP_FAILED: "sign_up_failed",
  LOGIN_FAILED: "login_failed",
  ERROR: "error",
  SWITCH_TO_BUS: "switch_to_bus",
  SAVE_INVOICE: "save_invoice",
  GO_TO_DATE: "go_to_date",
  CHECK_RESERVATION: "check_reservation",
  ONLINE_CHECKIN: "online_checkin",
  ONLINE_CHECKIN_RESERVATION_REDIRECT: "online_checkin_reservation_redirect",
  NO_SEARCH_RESULT: "no_search_result",
  SIGN_UP: "sign_up",
  LOGIN: "login",
  QUERY_CREDIT_CARD_POINTS: "query_credit_card_points",
  CONVERT_TO_TURNA_POINTS: "convert_to_turna_points",
  CONVERT_TO_TURNA_POINTS_COMPLETE: "convert_to_turna_points_complete",
  RESERVATION_TIMEOUT: "reservation_timeout",
};
